// extracted by mini-css-extract-plugin
module.exports = {"lockScroll":"BodyScrollLock_lockScroll__Zuk8e"};